import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@larab.com.br");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Acesso restrito a administradores");
        setLoading(false);
        return;
      }
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciais inválidas");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#4A3B40] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl p-8 shadow-xl">
        <div className="text-center mb-6"><Logo size="lg" /></div>
        <h1 className="font-serif text-2xl text-[#4A3B40] text-center">Painel Lara B.</h1>
        <p className="text-center text-sm text-[#8C7A80] mb-6">Acesso administrativo</p>
        <form onSubmit={submit} className="space-y-3">
          <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full border border-[#F9E1E8] bg-[#FFF9FA] rounded-xl px-4 py-3 outline-none" data-testid="admin-login-email" />
          <input type="password" required placeholder="Senha" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full border border-[#F9E1E8] bg-[#FFF9FA] rounded-xl px-4 py-3 outline-none" data-testid="admin-login-password" />
          <button disabled={loading} className="w-full btn-lara" data-testid="admin-login-submit">{loading?"Entrando...":"Entrar no painel"}</button>
        </form>
      </div>
    </div>
  );
}
